const initialState = {
  isLogInOpen: false,
  isSignUpOpen: false,
};

const authModalsReducer = (state = initialState, action) => {
  switch (action.type) {
  case "TOGGLE_LOGIN_MODAL":
    return { ...state, isLogInOpen: action.payload };
  case "TOGGLE_SIGNUP_MODAL":
    return { ...state, isSignUpOpen: action.payload };
  default:
    return state;
  }
};

export default authModalsReducer;
